// extracted by mini-css-extract-plugin
module.exports = {"DSP":"DSP_DSP__2ROsx","DSPModals":"DSP_DSPModals__2TMoa","Sketch":"DSP_Sketch__1CRpz"};